import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminBeneficiariesService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/admin/beneficiary', {
        create: '',
        index: '',
        search: '/search',
      }),
    }
  }

  static create() {
    return new AdminBeneficiariesService()
  }

  async queryBeneficiaries(filters, params) {
    const serverMapper = {
      beneficiaryName: 'name',
      'jurisdiction.logo': 'jurisdiction',
      website: 'website',
      active: 'active',
      category: 'category',
      subCategory: 'subCategory',
      id: 'id',
      externalId: 'externalId',
      registrationDate: 'date',
      email: 'email',
    }

    let sortString = ''
    if (params.sort && params.sort.length > 0) {
      // Convert sort parameters to string format expected by API
      sortString = params.sort
        .map(sort => {
          const field = serverMapper[sort.id] || sort.id
          const direction = sort.desc ? 'desc' : 'asc'
          return `${field},${direction}`
        })
        .join(';')
    }

    const servicePath = this.endpoints.search()

    // Create API parameters
    const apiParams = {
      page: params.page,
      size: params.pageSize,
      sort: sortString || undefined // Only include if there's a sort value
    };

    // Create a copy of filters to modify
    const requestBody = { ...filters };

    // Handle marketingPromotion properly based on its type
    if (requestBody.marketingPromotion !== undefined) {
      // If it's already in the correct format (an object with value property), ensure it has an operator
      if (typeof requestBody.marketingPromotion === 'object' &&
        requestBody.marketingPromotion.value !== undefined) {
        // Add operator if missing
        if (!requestBody.marketingPromotion.operator) {
          requestBody.marketingPromotion.operator = '=';
        }
      }
      // If it's a boolean, convert it to the expected object format with operator
      else if (typeof requestBody.marketingPromotion === 'boolean') {
        requestBody.marketingPromotion = {
          value: requestBody.marketingPromotion,
          operator: '='
        };
      }
      // Otherwise, remove invalid format
      else {
        delete requestBody.marketingPromotion;
      }
    }

    const { data } = await axios.post(servicePath, requestBody, { params: apiParams })
    return data
  }

  async getBeneficiariesById(id) {
    // don't work on disabled member
    const servicePath = this.endpoints.index()
    const { data } = await axios.get(`${servicePath}/${id}`)
    return data
  }

  async createBeneficiary(createBeneReq) {
    const servicePath = this.endpoints.create()
    const { data } = await axios.post(servicePath, createBeneReq)
    return data
  }
}
